import { dollarsNoCentsWithSymbol } from 'helpers/currency';
import React, { Fragment } from 'react';
import { AddonType, AttributeNameType, FormData, PriceTypes } from './types';

export const addonAttributeNameMapper = <T extends string = AttributeNameType>(name: T) => {
  switch (name) {
    case 'price_cents': {
      return 'Price';
    }
    case 'price_type': {
      return 'Price type';
    }
    case 'max_quantity': {
      return 'Max quantity';
    }
    case 'description': {
      return 'Description';
    }
    default: {
      return 'N/A';
    }
  }
};

export const transformBreakLineDescription = (description: string) =>
  description
    .split('\n')
    .filter((e, index, arr) => (index === arr.length - 1 ? Boolean : true))
    .map((line) => (
      <Fragment key={line}>
        {line} <br />
      </Fragment>
    ));

export const addonPriceTypeMapper = (type: string) => {
  switch (type) {
    case PriceTypes.PER_HOUR: {
      return 'per hour';
    }
    case PriceTypes.PER_PASSENGER: {
      return 'per passenger';
    }
    case PriceTypes.PER_BOOKING: {
      return 'per booking';
    }
    default: {
      return 'N/A';
    }
  }
};

export const getDefaultValues = ({
  id,
  name,
  addonOptionId,
  price_cents: priceData,
  price_type: priceType,
  max_quantity,
  description,
  add_on,
}: AddonType): Required<FormData> => {
  const defaultValues: Required<FormData> = {
    id,

    addonOption: {
      label: name,
      value: addonOptionId,
    },
    price: Number(priceData) / 100,
    priceType,
    priceTypes: add_on.allowed_price_types,
    quantity: {
      label: String(max_quantity),
      value: Number(max_quantity),
    },
    description,
  };

  return defaultValues;
};

export const addonAttributesUIMapper = (attributes: Omit<AddonType, 'name'>) =>
  Object.entries(attributes)
    .filter(([key]) => !['id', 'addonOptionId'].includes(key))
    .reduce((acc, [key, value]) => {
      switch (key) {
        case 'price_type': {
          return {
            ...acc,
            [key]: {
              label: addonAttributeNameMapper(key),
              value: addonPriceTypeMapper(value as PriceTypes),
            },
          };
        }

        case 'price_cents': {
          return {
            ...acc,
            [key]: {
              label: addonAttributeNameMapper(key),
              value: dollarsNoCentsWithSymbol(Number(value)),
            },
          };
        }

        default: {
          return {
            ...acc,
            [key]: {
              label: addonAttributeNameMapper(key),
              value,
            },
          };
        }
      }
    }, {});

export const sortAddonsByName = (addonList: AddonType[]): AddonType[] =>
  addonList.slice().sort((current, next) => current.name?.localeCompare(next?.name));
